import Typography from '@mui/material/Typography'

export default function Lopd ({ contacto, empresa, date }) {
  return (
    <>
      <Typography variant='body1'>
        {
        'Los datos personales facilitados serán tratados únicamente a efectos de archivo' +
        ' del historial de tratamientos recibidos y a efectos de las comunicaciónes entre ' +
        ` ${empresa.razon} y el cliente, referidas estrictamente a la prestación` +
        'de los servicios de fisioterapia. No se permite ningún otro uso de los datos.\n\n'
      }
      </Typography>
      <Typography variant='body1'>
        Los datos personales facilitados serán almacenados mientras sean necesarios para la
        prestación del servicio.
      </Typography>
      <Typography variant='body1'>
        Este documento constituye la base legal que legitima el tratamiento de los datos.
      </Typography>
      <Typography variant='body1'>
        {'No está permitida ninguna cesión de estos datos, salvo las legal o judicialmente ' +
        `exigidas a ${empresa.razon}.`}
      </Typography>
      <Typography variant='body1'>
        El cliente tiene derecho a acceder a sus datos personales, así como a solicitar su
        rectificación o su eliminación.
      </Typography>
      <Typography variant='body1'>
        Y en señal de conformidad firmo el presente documento
      </Typography>
      <Typography textAlign='center' variant='subtitle2' className='firma'>
        {`En ${empresa.ayuntamiento}, a ${date}\n`}
      </Typography>
      <Typography variant='subtitle2'>
        {contacto?.razon}
      </Typography>
    </>
  )
}
